export const VISITOR_UPLOADS_FOLDER_ID = 'visitor-uploads';
